import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import WedgeWireProfileDiagram from "@/components/diagrams/WedgeWireProfileDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const DIAGRAM_COPY = {
  en: {
    title: "Continuous Slot Screen Pipe Radial Geometry",
    lead: "All-welded circumferential V-wires on longitudinal support rods provide high collapse resistance and continuous inflow slots."
  },
  zh: {
    title: "连续缝隙滤水筛管径向截面与流向示意",
    lead: "连续梯形轮廓丝全焊于纵向支撑骨架外侧，提供高抗压溃能力与顺畅的环向进水微米级缝隙通道。"
  },
  es: {
    title: "Geometría Radial de Tubería de Ranura Continua",
    lead: "Hilos continuos en V soldados sobre varillas longitudinales asegurando resistencia al colapso y entrada de fluido sin obstrucciones."
  },
  de: {
    title: "Spaltsiebrohr-Radialgeometrie & Strömungsführung",
    lead: "Vollverschweißte Umfangsdrähte auf Längstragstäben sichern hohe Kollapsfestigkeit und kontinuierliche Einströmung."
  },
  fr: {
    title: "Géométrie Radiale du Tube Crépine à Fente Continue",
    lead: "Fils profilés circonférentiels soudés sur des tiges longitudinales conférant une haute résistance à l'écrasement."
  },
  pt: {
    title: "Geometria Radial do Tubo de Peneira de Ranhura Contínua",
    lead: "Arames circunferenciais soldados sobre barras longitudinais garantindo alta resistência ao colapso e vazão desobstruída."
  }
};
export default function ScreenPipesPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = pick(lang, DIAGRAM_COPY);
  const diagram = <DiagramSection id="screen-pipes-diagram" title={diagramCopy.title} lead={diagramCopy.lead} tone="muted">
      <div className="max-w-xl mx-auto">
        <WedgeWireProfileDiagram variant="cylinder" />
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}